<template>
  <div class="dashboard">
    <section>
      <div class="header">
        <div class="title-box">
          <span class="title">UPCOMING EVENT(1)</span>
        </div>
      </div>
      <div class="lists">
        <booking-box-up-coming-event></booking-box-up-coming-event>
      </div>
      <div class="view-all">
        <router-link :to="{ path: '/user/booking' }">VIEW ALL</router-link>
      </div>
    </section>
    <section>
      <div class="header">
        <div class="title-box">
          <span class="title">MESSAGE(1)</span>
        </div>
      </div>
      <div class="lists">
        <message-box></message-box>
      </div>
      <div class="view-all">
        <router-link :to="{ path: '/user/message' }">VIEW ALL</router-link>
      </div>
    </section>
    <section>
      <div class="header">
        <div class="title-box">
          <span class="title">ALBUM(1)</span>
        </div>
      </div>
      <div class="lists">
        <album-box></album-box>
      </div>
      <div class="view-all">
        <router-link :to="{ path: '/user/message' }">VIEW ALL</router-link>
      </div>
    </section>
  </div>
</template>

<script>
// import RequestBox from '@/components/common/RequestBox'
import BookingBoxUpComingEvent from '../common/BookingBoxUpComingEvent'
// import BookingBoxNeedToUpload from '@/components/common/BookingBoxNeedToUpload'
import MessageBox from '../common/MessageBox'
import AlbumBox from '../common/AlbumBox'
// import ImageUploadType1 from '@/components/common/ImageUploadType1'

export default {
  name: 'dashboard',
  components: {
    AlbumBox,
    // ImageUploadType1,
    MessageBox,
    // BookingBoxNeedToUpload,
    BookingBoxUpComingEvent
    // RequestBox
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  section {
    margin-bottom: 40px;
    .header {
      display: flex;
      .title-box {
        margin-bottom: 10px;
        width: 100%;
        height: 60px;
        background-color: #ffffff;
        border-left: solid 1px #e7e7e7;
        border-top: solid 1px #e7e7e7;
        border-right: solid 1px #e7e7e7;
        text-align: center;
        .title {
          line-height: 60px;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
          text-align: center;
          color: #ab08b6;
        }
      }
    }
    .view-all {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px auto 30px auto;
      position: relative;
      width: 240px;
      height: 50px;
      border-radius: 2px;
      background-color: #ffffff;
      border: solid 1px #dddddd;
      span {
        width: 33px;
        height: 23px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: center;
        color: #000000;
      }
    }
  }
}
</style>
